/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";


const host = window.location.hostname;
if (window.location.href.indexOf("localhost:4200") > 0) {
  debugger
  environment.APPLICATION_ID = "6";
  environment.applicationId = 6;
  environment.API_SECURITY_KEY =
    "basic NjpKQUlOSU5URVJOQVRJT05BTDpKSS0yMDI0OkpJOkVORC1VU0VS";
}
if (window.location.href.indexOf("rajputsclub") > 0) {
  environment.APPLICATION_ID = "2";
  environment.applicationId = 2;
  environment.API_SECURITY_KEY =
    "basic MjpSQUpQVVRTQ0xVQjpSWUMtMjAyMjpSWUM6RU5ELVVTRVI=";
}

if (window.location.href.indexOf("https://cs710032001550166df.z21.web.core.windows.net") > 0) {
  environment.APPLICATION_ID = "2";
  environment.applicationId = 2;
  environment.API_SECURITY_KEY =
    "basic MjpSQUpQVVRTQ0xVQjpSWUMtMjAyMjpSWUM6RU5ELVVTRVI=";
} else if (
  host.includes("rajputsclub") ||
  host.includes("cs710032001550166df")
) {
  console.log("Loaded config: rajputsclub");
  environment.APPLICATION_ID = "2";
  environment.applicationId = 2;
  environment.API_SECURITY_KEY =
    "basic MjpSQUpQVVRTQ0xVQjpSWUMtMjAyMjpSWUM6RU5ELVVTRVI=";
} else if (host.includes("easylaworder")) {
  console.log("Loaded config: easylaworder");
  environment.APPLICATION_ID = "4";
  environment.applicationId = 4;
  environment.API_SECURITY_KEY =
    "basic NDpFQVNZTEFXT1JERVI6RUwtMjAyNDpFTDpFTkQtVVNFUg==";
} else if (host.includes("rajasthancircle")) {
  console.log("Loaded config: rajasthancircle");
  environment.APPLICATION_ID = "1";
  environment.applicationId = 1;
  environment.API_SECURITY_KEY =
    "basic MTpNWVJBSkFTVEhBTkNMVUI6TVJDLTIwMjI6TVJDOkVORC1VU0VS";
} else {
  console.warn("No environment match found — loading default settings");
}

if (window.location.href.indexOf("jaindigital") > 0) {
  environment.APPLICATION_ID = "6";
  environment.applicationId = 6;
  environment.API_SECURITY_KEY =
    "basic NjpKQUlOSU5URVJOQVRJT05BTDpKSS0yMDI0OkpJOkVORC1VU0VS";
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
